import i18next from 'i18next';

export const getLocalizedText = (i18n: i18next.i18n, value: string): string => {
  return i18n.t([`enums.annexedCategory.${value.toUpperCase()}`, value]);
};
